<!--
 * @Author: Gaho
 * @Date: 2024-05-29 16:43:41
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-23 14:11:37
 * @Description: 需要给 mutiConfig 数据传递到 <Board> 
-->
<template>
    <div class="py-4">
        <Board
            :is-auto="true"
            :is-submiting="true"
            :savedPredictions="[]"
            :animate-enabled="false"
            :round="{
                ...round,
            }"
            :fields="round.rounds"
            :currentMutiplier="1"
            :disabled-mutipler="true"
            :mutiConfig="mutiConfig"
            :multiInfoShowDuration="2_000"
            :predictionSending="false"
        >
        </Board>
    </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import Board from '~/pages/casino/towerGame/_components/Board.vue';
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';
import { mutiConfigObj } from '@/pages/casino/towerGame/data/index';
import { useGameListSocket } from '@/socket/gamelist/index';
import { oGameName2Api } from '@/common/js/gameAbout';


const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        required: true,
    },
});
const round = ref<BetHistoryType>(props.history);

const { EMIT_GET_GAME_CONFIG } = useGameListSocket();
const mutiConfig = reactive(deepCopy(mutiConfigObj));

const fnGetTowerConfig = ()=>{
    EMIT_GET_GAME_CONFIG(
        {game: oGameName2Api.towerGame},
        (oData)=>{
            if (!oData || oData.error) {
                console.error('查询游戏配置失败', oData); 
                return;
            }
            const {coefficients} = oData.config;
            Object.assign(mutiConfig, coefficients);
            console.log(`${oGameName2Api.towerGame} 游戏配置`, deepCopy(mutiConfig));
        }
    );
}

if (import.meta.client){
    fnGetTowerConfig();
}

onMounted(() => {
    const { prediction, rounds } = props.history;
    const index = prediction.findIndex((ele, ind) => rounds[ind].includes(ele));
    if (index === -1){
        return;
    }
    round.value = {
        ...round.value,
        prediction: prediction.slice(0, index + 1),
    }
})
</script>

<style></style>
